import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommonConfig } from "../../constants/common-config";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient) { }

  login(username: string, password: string): Observable<any> {
    return this.http.post(
      environment.apiUrl + "/auth/signin",
      {
        username,
        password,
      },
      CommonConfig.HTTP_OPTIONS
    );
  }

  resetPassword(username: string): Observable<any> {
    return this.http.post(environment.apiUrl + "/auth/resetpassword", {
      username,
    });
  }

  resetPasswordStep2(username: string, password: string): Observable<any> {
    return this.http.post(environment.apiUrl + "/auth/resetpassword-step2", {
      username,
      password,
    });
  }
}
